// extracted by mini-css-extract-plugin
export var filterIncDec = "_b5-0";
export var leftBorder = "_b5-1";
export var rightBorder = "_b5-2";
export var stringInput = "_b5-3";